export const messages = {
  en: {
    serviceManage: {
      queryCondition: 'Query Conditions',
      enterServiceName: 'Please enter service name',
      enterServiceCode: 'Please enter service code',
      enterServiceUrl: 'Please enter service URL',
      query: 'Query',
      reset: 'Reset',
      serviceInfo: 'Service Information',
      addService: 'Add Service',
      serviceId: 'Service ID',
      serviceName: 'Service Name',
      url: 'Service URL',
      serviceCode: 'Service Code',
      serviceUrl: 'Service URL',
      serviceMethod: 'Service Method',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete'
    },
    addService: {
      addService: 'Add Service',
      serviceName: 'Service Name',
      enterServiceName: 'Required, please enter service name',
      serviceCode: 'Service Code',
      enterServiceCode: 'Required, please enter service code',
      serviceUrl: 'Service URL',
      selectServiceUrl: 'Required, please select service URL',
      serviceMethod: 'Service Method',
      selectServiceMethod: 'Required, please select service method',
      timeout: 'Timeout',
      enterTimeout: 'Required, please enter timeout',
      retryCount: 'Retry Count',
      enterRetryCount: 'Required, please enter retry count',
      cancel: 'Cancel',
      save: 'Save',
      serviceNameRequired: 'Service name is required',
      serviceNameMaxLength: 'Service name cannot exceed 200 characters',
      serviceCodeRequired: 'Service code is required',
      serviceCodeLength: 'Service code must be between 2-100 characters',
      methodRequired: 'Service method is required',
      timeoutRequired: 'Timeout is required',
      timeoutNumber: 'Timeout must be a number',
      retryCountRequired: 'Retry count is required',
      retryCountNumber: 'Retry count must be a number',
      saveSuccess: 'Service added successfully'
    },
    editService: {
      editService: 'Edit Service',
      serviceName: 'Service Name',
      enterServiceName: 'Required, please enter service name',
      serviceCode: 'Service Code',
      enterServiceCode: 'Required, please enter service code',
      serviceUrl: 'Service URL',
      selectServiceUrl: 'Required, please select service URL',
      serviceMethod: 'Service Method',
      selectServiceMethod: 'Required, please select service method',
      timeout: 'Timeout',
      enterTimeout: 'Required, please enter timeout',
      retryCount: 'Retry Count',
      enterRetryCount: 'Required, please enter retry count',
      cancel: 'Cancel',
      save: 'Save',
      serviceNameRequired: 'Service name is required',
      serviceNameMaxLength: 'Service name cannot exceed 50 characters',
      serviceCodeRequired: 'Service code is required',
      serviceCodeLength: 'Service code must be between 2-100 characters',
      methodRequired: 'Service method is required',
      timeoutRequired: 'Timeout is required',
      timeoutNumber: 'Timeout must be a number',
      retryCountRequired: 'Retry count is required',
      retryCountNumber: 'Retry count must be a number',
      serviceIdRequired: 'Service ID is required',
      saveSuccess: 'Service updated successfully'
    },
    deleteService: {
      confirmOperation: 'Please confirm your operation',
      confirmDeleteService: 'Are you sure to delete this service?',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      deleteSuccess: 'Service deleted successfully',
      deleteFailed: 'Failed to delete service'
    }
  },
  zh: {
    serviceManage: {
      queryCondition: '查询条件',
      enterServiceName: '请输入服务名称',
      enterServiceCode: '请输入服务编码',
      enterServiceUrl: '请输入调用地址',
      query: '查询',
      reset: '重置',
      serviceInfo: '服务信息',
      addService: '添加服务',
      serviceId: '服务ID',
      url: '调用地址',
      serviceName: '服务名称',
      serviceCode: '服务编码',
      serviceUrl: '调用地址',
      serviceMethod: '调用方式',
      operation: '操作',
      edit: '修改',
      delete: '删除'
    },
    addService: {
      addService: '添加服务',
      serviceName: '服务名称',
      enterServiceName: '必填，请填写服务名称',
      serviceCode: '服务编码',
      enterServiceCode: '必填，请填写服务编码',
      serviceUrl: '调用服务',
      selectServiceUrl: '必填，请选择调用服务',
      serviceMethod: '调用方式',
      selectServiceMethod: '必填，请选择调用方式',
      timeout: '超时时间',
      enterTimeout: '必填，请填写超时时间',
      retryCount: '重试次数',
      enterRetryCount: '必填，请填写重试次数',
      cancel: '取消',
      save: '保存',
      serviceNameRequired: '服务名称不能为空',
      serviceNameMaxLength: '服务名称不能超过200字符',
      serviceCodeRequired: '服务编码不能为空',
      serviceCodeLength: '服务编码必须在2至100字符之间',
      methodRequired: '调用方式不能为空',
      timeoutRequired: '超时时间不能为空',
      timeoutNumber: '超时时间必须为数字',
      retryCountRequired: '重试次数不能为空',
      retryCountNumber: '重试次数必须为数字',
      saveSuccess: '添加成功'
    },
    editService: {
      editService: '修改服务',
      serviceName: '服务名称',
      enterServiceName: '必填，请填写服务名称',
      serviceCode: '服务编码',
      enterServiceCode: '必填，请填写服务编码',
      serviceUrl: '调用服务',
      selectServiceUrl: '必填，请选择调用服务',
      serviceMethod: '调用方式',
      selectServiceMethod: '必填，请选择调用方式',
      timeout: '超时时间',
      enterTimeout: '必填，请填写超时时间',
      retryCount: '重试次数',
      enterRetryCount: '必填，请填写重试次数',
      cancel: '取消',
      save: '保存',
      serviceNameRequired: '服务名称不能为空',
      serviceNameMaxLength: '服务名称不能超过50字符',
      serviceCodeRequired: '服务编码不能为空',
      serviceCodeLength: '服务编码必须在2至100字符之间',
      methodRequired: '调用方式不能为空',
      timeoutRequired: '超时时间不能为空',
      timeoutNumber: '超时时间必须为数字',
      retryCountRequired: '重试次数不能为空',
      retryCountNumber: '重试次数必须为数字',
      serviceIdRequired: '服务ID不能为空',
      saveSuccess: '修改成功'
    },
    deleteService: {
      confirmOperation: '请确认您的操作',
      confirmDeleteService: '确定删除服务吗？',
      cancel: '点错了',
      confirmDelete: '确认删除',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败'
    }
  }
}